module.exports = __webpack_public_path__ + "static/media/support-noCirc.28b32c56.svg";